import { FC, DragEvent, Fragment } from 'react';
import cx from 'classnames/bind';

import { Message } from '@/components/Message';
import { Cursor } from '@/components/Cursor';
import type { IAnswer } from '@/types/answer';

import styles from './Answers.module.scss';

interface AnswersProps {
  answers: IAnswer[];
  selectedAnswer?: string[];
  onDragStart: (e: DragEvent<HTMLDivElement>) => void;
  state?: number;
  isTraining?: boolean;
  isMultiple?: boolean;
  className?: string;
}

const cn = cx.bind(styles);

const Answers: FC<AnswersProps> = ({
  answers,
  selectedAnswer,
  onDragStart,
  state,
  isTraining,
  isMultiple = false,
  className,
}) =>
  isMultiple ? (
    <div className={cn('multiple-answers', className)}>
      {answers.map((item) => (
        <div
          key={item.id}
          draggable
          onDragStart={onDragStart}
          className={cn('answer')}
        >
          {item.text}
        </div>
      ))}
    </div>
  ) : (
    <div className={cn('answers', className)}>
      {answers.map(({ id, text }) => (
        <Fragment key={id}>
          <Message
            isDraggable={!selectedAnswer?.length}
            onDragStart={onDragStart}
            id={id}
            className={
              selectedAnswer?.length
                ? cn('message-answer', 'message-disabled')
                : cn('message-answer')
            }
          >
            {text}
          </Message>
          {isTraining && state === 0 && id === 2 && (
            <Cursor direction="right" className={cn('cursor')} />
          )}
        </Fragment>
      ))}
    </div>
  );

export default Answers;
